import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Tooltip,
} from '@chakra-ui/react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import type { ReactElement } from 'react'
import type { CmFormValues } from '../../../../interfaces/FileDetailsResponse'
import type { CMFieldProps } from '.'
import EllipsisMiddle from '../../../EllipsisMiddle'
import { isNull, isUndefined } from 'lodash'

const CMTextField = ({ cmField, disabled, validator,isUpload }: CMFieldProps): ReactElement => (
  <Field name={`['${cmField.name}']`} key={`['${cmField.name}']`} validate={validator}>
    {({ field, form }: FieldProps<string, CmFormValues>) =>
    (
      <FormControl
        isInvalid={Boolean(
          form.errors[cmField.name]
        )}
        isRequired={cmField.schema.isValueRequired}
        isDisabled={disabled}
      >
        <Tooltip label={cmField.label} placement="top-start">
          <FormLabel requiredIndicator={<></>}>
            <Flex maxWidth="20vw">
              <EllipsisMiddle text={cmField.label} required={cmField.schema.isValueRequired} className="centerText" />
            </Flex>
          </FormLabel>
        </Tooltip>
        <Input
          {...field}
          type="text"
          value={field.value || ''}
          disabled={disabled}
          readOnly={disabled}
          placeholder={(!(isUndefined(cmField.schema.defaultValue) || isNull(cmField.schema.defaultValue)) && isUpload ? `${cmField.schema.defaultValue} (Default value)` : "")}
          onChange={e => {
            const value = e.target.value
            if (value.length === 0) {
              form.setFieldValue(field.name, null)
            } else {
              form.setFieldValue(field.name, value)
            }
          }}
        />
        <FormErrorMessage>{form.errors[cmField.name]}</FormErrorMessage>
      </FormControl>
    )}
  </Field>
)

export default CMTextField
